import { ErrorLogComponent } from '@cian/error-log-component';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { IApplicationState } from './types/redux';
import { EDeviceType } from './types/device';

import { PageContainer } from './containers/Page';
import { Config } from '@cian/config/shared';
import { ILogger } from '@cian/logger/shared';
import { IHttpApi } from '@cian/http-api/shared';

import './App.css';
import { logComponentError } from './utils/logs';

export interface IApplicationProps {
  context: IApplicationContext;
  store: Store<IApplicationState>;
  fromNode?: boolean;
}

export interface IApplicationContext {
  config: Config;
  logger: ILogger;
  httpApi: IHttpApi;
  deviceType: EDeviceType;
}

export class Application extends React.Component<IApplicationProps> {
  public context: IApplicationContext;

  public static childContextTypes = {
    config: PropTypes.object,
    httpApi: PropTypes.object,
    logger: PropTypes.object,
    deviceType: PropTypes.string,
  };

  // // TODO: переделать на React Context API

  public getChildContext() {
    const {
      page: { deviceType },
    } = this.props.store.getState();

    return {
      config: this.props.context.config,
      deviceType,
      httpApi: this.props.context.httpApi,
      logger: this.props.context.logger,
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logComponentError({
      error,
      errorInfo,
      logger: this.props.context.logger,
    });
  }

  public render() {
    const {
      context: { logger },
      store,
    } = this.props;

    return (
      <ErrorLogComponent logger={logger}>
        <Provider store={store}>
          <PageContainer />
        </Provider>
      </ErrorLogComponent>
    );
  }
}
